<!-- 查看销售订单页面-->
<template>
    <div class="business-content-main" v-loading="loading">
        <div>
            <div class="bread-nav">
                <!-- <el-button size="small" icon="el-icon-back" class="search-btn btn-primary" @click="goback()" style="margin-right: 10px"></el-button>
                <breadcrumb></breadcrumb> -->

                <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
            </div>
            <!--   订单信息     -->
            <div class="section-title">
                <div class="space-between">
                    <span>订单信息【{{ orderData.OrderCode }}】</span>
                    <span v-if="isUseSource" style="display: inline-block">订单来源：{{ orderData.CusSourcesName }}</span>
                </div>
            </div>
            <div class="order-infoes">
                <el-form :model="orderData" ref="formMsg" label-width="90px" style="width: 100%; padding-right: 10px; padding-left: 10px">
                    <el-row :gutter="20">
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="客户" prop="EntpCusId">
                                    <el-input size="small" disabled v-model="orderData.EntpCusName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="业务员" prop="SId">
                                    <el-input size="small" disabled v-model="orderData.SName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="联系电话" prop="PhoneNum">
                                    <el-input size="small" disabled v-model="orderData.PhoneNum"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="发货方式" prop="ShipType">
                                    <el-input size="small" disabled v-model="orderData.ShipTypeName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content bg-purple">
                                <el-form-item label="运输费用" prop="ShipAmount">
                                    <el-input size="small" disabled v-model="orderData.ShipAmount"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="结算方式" prop="PayType">
                                    <el-input size="small" disabled v-model="orderData.PayTypeName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="出仓仓库" prop="WarehouseId">
                                    <el-input size="small" disabled v-model="orderData.WHName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5" v-if="funcConfig">
                            <div class="grid-content bg-purple">
                                <el-form-item label="跟单采购员" prop="SId">
                                    <el-input size="small" disabled v-model="orderData.Follower"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="grid-content bg-purple">
                                <el-form-item label="物流公司" prop="LogisticName">
                                    <el-input size="small" disabled v-model="orderData.LogisticName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <div class="grid-content bg-purple">
                                <el-form-item label="物流单号" prop="LogisticsOrderNo">
                                    <el-input size="small" disabled v-model="orderData.LogisticsOrderNo"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="10">
                            <div class="grid-content bg-purple">
                                <el-form-item label="收货地址" prop="FullAddress">
                                    <el-input size="small" disabled v-model="orderData.FullAddress"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="客人要求" class="grid-content bg-purple">
                                <el-input size="small" disabled v-model="orderData.Remark"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4" v-if="isOrgShow">
                            <div class="grid-content bg-purple">
                                <el-form-item label="部门" prop="OrgId">
                                    <el-input size="small" disabled v-model="orderData.OrgName"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="orderImages.length > 0 && permission.flowVoucher">
                        <el-col :span="24">
                            <div class="form-uploadImg">
                                <div>流水单据：</div>
                                <el-upload
                                    action=""
                                    :file-list="orderImages"
                                    :disabled="true"
                                    list-type="picture-card"
                                    accept="image/jpeg, image/png"
                                    :on-preview="onUploadPreview"
                                    class="hideUpload"
                                >
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                                <el-dialog :visible.sync="dialogImageVisible">
                                    <img width="100%" :src="dialogImageUrl" alt="" />
                                </el-dialog>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <!--    收款记录 -- 操作记录    -->
            <el-row :gutter="20">
                <el-col :span="16">
                    <div class="grid-content">
                        <!--   收款记录     -->
                        <div :class="showRAndPMsg ? 'section-title' : 'section-title section-magin'">
                            <div>收款记录</div>
                            <div class="img-e-op" @click="showRPMsg" v-show="!showRAndPMsg">
                                <img src="../../../assets/images/down-e.png" />
                            </div>
                            <div class="img-e-op" @click="hideRPMsg" v-show="showRAndPMsg">
                                <img src="../../../assets/images/up-e.png" />
                            </div>
                        </div>
                        <div class="table-ctn" v-show="showRAndPMsg">
                            <el-table
                                :header-cell-style="{ background: '#F2F6FC' }"
                                :data="receiveRecords"
                                border=""
                                :max-height="250"
                                show-summary
                                :summary-method="getSummaries_apply"
                                style="width: 100%; margin-bottom: 10px; margin-top: 0px"
                            >
                                <el-table-column show-overflow-tooltip width="190px" prop="PayCode" label="流水号"></el-table-column>
                                <el-table-column show-overflow-tooltip width="150px" prop="SumPayable" label="订单总金额"></el-table-column>
                                <el-table-column show-overflow-tooltip width="150px" prop="ApplyPay" label="申请收款金额"></el-table-column>
                                <el-table-column show-overflow-tooltip width="150px" prop="NowPay" label="实收金额"></el-table-column>
                                <el-table-column show-overflow-tooltip width="150px" prop="PayTypeName" label="结算方式">
                                    <template slot-scope="scope">
                                        <el-popover
                                            placement="right"
                                            width="400"
                                            trigger="click"
                                            v-if="
                                                (scope.row.PayType == '20' || scope.row.PayType == '25' || scope.row.PayType == '30' || scope.row.PayType == '35') &&
                                                (scope.row.Bank || scope.row.AccountName || scope.row.Account)
                                            "
                                        >
                                            <div class="account-info">
                                                <span v-if="scope.row.Bank">
                                                    {{ '开户行：' + scope.row.Bank }}
                                                </span>
                                                <span v-if="scope.row.AccountName">
                                                    {{ '账户名：' + scope.row.AccountName }}
                                                </span>
                                                <span v-if="scope.row.Account">
                                                    {{ '账号：' + scope.row.Account }}
                                                </span>
                                            </div>
                                            <i slot="reference" class="el-icon-info" style="font-size: 18px; color: #409eff" title="支付账号信息"></i>
                                        </el-popover>
                                        <span>{{ scope.row.PayTypeName }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip width="80px" prop="ApplyName" label="申请人"></el-table-column>
                                <el-table-column show-overflow-tooltip width="160px" prop="CreateTime" label="申请时间"></el-table-column>
                                <el-table-column show-overflow-tooltip min-width="100px" prop="Remark" label="备注"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <div :class="showOpRecordMsg ? 'section-title' : 'section-title section-magin'">
                            <div>
                                <span>操作记录</span>
                            </div>
                            <div class="img-e-op" @click="showOPMsg" v-show="!showOpRecordMsg">
                                <img src="../../../assets/images/down-e.png" />
                            </div>
                            <div class="img-e-op" @click="hideOPMsg" v-show="showOpRecordMsg">
                                <img src="../../../assets/images/up-e.png" />
                            </div>
                        </div>
                        <div class="table-ctn" v-show="showOpRecordMsg">
                            <el-table
                                :header-cell-style="{ background: '#F2F6FC' }"
                                :data="actionRecords"
                                border=""
                                :max-height="250"
                                style="width: 100%; margin-bottom: 10px; margin-top: 0px"
                            >
                                <el-table-column fixed show-overflow-tooltip label="操作类型" prop="OpTypeName"> </el-table-column>
                                <el-table-column show-overflow-tooltip min-width="200" prop="Remark" label="操作说明"></el-table-column>
                                <el-table-column show-overflow-tooltip width="160" prop="CreateTime" label="操作时间"></el-table-column>
                                <el-table-column show-overflow-tooltip width="80" prop="Oper" label="操作人"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <!--    table    -->
            <div class="section-title">
                <div>商品明细</div>
                <template v-if="permission2.editCheckSaleOrder && type == 1">
                    <el-button size="small" class="search-btn btn-primary" v-if="!isEdit" @click="isEdit = true">修改商品</el-button>
                    <el-button size="small" class="search-btn btn-primary" v-else-if="isEdit" @click="save">提交</el-button>
                </template>
            </div>
            <!-- table body -->
            <div class="table-ctn">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="dataList"
                    ref="multipleTable"
                    :summary-method="getSummaries"
                    show-summary
                    border=""
                    style="width: 100%"
                >
                    <el-table-column show-overflow-tooltip width="60px" type="index" label="序号"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="170px" prop="APCode" label="汽配编码">
                        <template slot-scope="scope">
                            <div class="apcode-cell">
                                <img class="info-icon" src="../../../assets/images/info.png" title="配件信息" @click.stop="showAPMsgDialog(scope.row.GoodsId)" />
                                <span>{{ scope.row.APCode }}</span>
                                <el-tag v-if="scope.row.State == 1" class="tag" type="warning" size="small">已删除</el-tag>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip min-width="200px" prop="GoodName" label="配件名称"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="160px" prop="AutoSerise" label="车型"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="90px" prop="Brand" v-if="isShowBrand" label="品牌" key="Brand"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="100px" prop="Origin" v-if="isOriginShow" label="产地" key="Origin"></el-table-column>
                    <el-table-column show-overflow-tooltip min-width="120px" prop="Size" v-if="isSizeShow" label="规格" key="Size"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="Count" label="数量"></el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="Unit" label="单位"></el-table-column>
                    <el-table-column :width="!isEdit ? '100px' : '150px'" prop="Price" label="销售价">
                        <template slot-scope="scope">
                            <div class="apcode-cell" v-if="!isEdit">
                                <img class="info-icon" src="../../../assets/images/info.png" title="历史销售" @click.stop="showHistoryDialog(scope.row.GoodsId)" />
                                <span>{{ scope.row.Price }}</span>
                            </div>
                            <div class="apcode-cell" v-else>
                                <el-input-number
                                    class="purcounts-input-cell"
                                    style="width: 135px"
                                    type="number"
                                    :min="0"
                                    :step="0.1"
                                    :precision="2"
                                    controls-position="right"
                                    size="small"
                                    v-model="scope.row.Price"
                                    @change="priceChange"
                                ></el-input-number>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :width="!isEdit && isBPriceShow ? '100px' : '150px'" v-if="isBPriceShow" prop="BillingPrice" label="开单价" key="BillingPrice">
                        <template slot-scope="scope">
                            <div class="apcode-cell" v-if="!isEdit && isBPriceShow">
                                <span>{{ scope.row.BillingPrice }}</span>
                            </div>
                            <div class="apcode-cell" v-else>
                                <el-input-number
                                    class="purcounts-input-cell"
                                    style="width: 135px"
                                    type="number"
                                    :min="0"
                                    :step="0.1"
                                    :precision="2"
                                    controls-position="right"
                                    size="small"
                                    v-model="scope.row.BillingPrice"
                                    @change="priceChange2"
                                ></el-input-number>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="120px" label="销售总计">
                        <template slot-scope="scope">
                            {{ (scope.row.Price * scope.row.Count).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip v-if="isUrgentShow" width="60px" prop="IsUrgent" label="急件">
                        <template slot-scope="scope">
                            {{ scope.row.IsUrgent }}
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="IsDelivery" label="是否出仓">
                        <template slot-scope="scope">
                            <div v-if="scope.row.IsDelivery">
                                <span style="color: #ff0097">已出仓</span>
                            </div>
                            <div v-else>{{ scope.row.WarehousedCount > 0 ? '部分出仓' : '未出仓' }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="100px" prop="OutDate" label="出仓日期">
                        <template slot-scope="scope">
                            <div v-if="scope.row.IsDelivery">
                                <span style="color: #ff0097">{{ scope.row.OutDate }}</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" title="配件信息" :visible.sync="APMsgVisible" width="1000px">
            <div v-if="APMsgVisible">
                <APMsg :dialogFormVisible="APMsgVisible" :EntpTempGoodsId="EntpTempGoodsIdEdit" @closeDialog="closeAPMsgDialog"></APMsg>
            </div>
        </el-dialog>
        <!--    销售历史    -->
        <el-dialog :close-on-click-modal="false" title="销售历史" :visible.sync="historyVisible" width="1200px">
            <div v-if="historyVisible">
                <APHistory
                    :EntpCusId="orderData.EntpCusId"
                    :EntpTempGoodsId="EntpTempGoodsIdEdit"
                    :EntpCusName="orderData.EntpCusName"
                    @closeDialog="closeHistoryDialog"
                ></APHistory>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import APMsg from '@/components/common/APMsg';
import APHistory from '@/components/common/APHistory';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
export default {
    mixins: [mixin],
    name: '',
    components: {
        APMsg,
        APHistory,
        breadcrumb
    },
    data() {
        return {
            loading: false,
            orderData: {},
            id: '',
            pageTitle: '查看销售订单',
            dataList: [],
            receiveRecords: [],
            showRAndPMsg: false,
            showOpRecordMsg: false,
            actionRecords: [],
            funcConfig: false,
            APMsgVisible: false, // 是否展示配件信息弹框
            historyVisible: false, // 是否展示销售价弹框
            EntpTempGoodsIdEdit: '', // 需要查看的配件ID
            permission: {},
            permission2: {},
            dialogImageUrl: '',
            dialogImageVisible: false,
            orderImages: [],
            isBPriceShow: false, //开单价
            isOrgShow: false, //开单部门
            isOriginShow: false, //产地
            isSizeShow: false, //规格
            CountSum: 0,
            SalesPriceSum: 0,
            BPriceSum: 0,
            isUseSource: false, //是否启用销售开单显示来源
            isShowBrand: false, //是否显示品牌
            isEdit: false,
            type: 0, //0 正常查看 1询价进入需要展示修改按钮
            entpCusId: '', //保存修改用
            isUrgentShow: false //急件
        };
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    mounted() {
        this.getConfigByCodes().then(() => {
            this.id = this.$route.query.id;
            if (this.$route.query.type) this.type = this.$route.query.type;
            if (this.$route.query.entpCusId) this.entpCusId = this.$route.query.entpCusId;

            this.permission = this.$util.getPermission('salesOrder');
            this.permission2 = this.$util.getPermission('CusReceivable_H');

            this.getEntpFuncConfigData();
            this.getOrderDetail();
        });
    },
    methods: {
        goback() {
            this.$router.push('/salesManage/salesOrder');
        },
        // 销售价格变动
        priceChange() {
            let DetailList = this.dataList;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allMoney += Number(DetailList[i].Count * DetailList[i].Price ? (DetailList[i].Count * DetailList[i].Price).toFixed(3) : 0);
            }
            this.SalesPriceSum = _allMoney.toFixed(2);
            this.orderData.SurplusMoney = (_allMoney + this.orderData.DiscountRate - this.orderData.DiscountAmount).toFixed(2);
        },
        // 开单价格变动
        priceChange2() {
            let DetailList = this.dataList;
            let _allMoney = 0;
            for (let i = 0; i < DetailList.length; i++) {
                _allMoney += Number(DetailList[i].Count * DetailList[i].BillingPrice ? (DetailList[i].Count * DetailList[i].BillingPrice).toFixed(3) : 0);
            }
            this.BPriceSum = _allMoney.toFixed(2);
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = ['xskdxskdj', 'xskdxskdbm', 'kdspcd', 'kdspgg', 'xsddly', 'kdxspp', 'xsdbsjj'];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            let rValue = data[i].RValue;
                            switch (code) {
                                case 'xskdxskdj':
                                    this.isBPriceShow = result;
                                    break;
                                case 'xskdxskdbm':
                                    this.isOrgShow = result;
                                    break;
                                case 'kdspcd': //是否出现产地
                                    this.isOriginShow = result;
                                    break;
                                case 'kdspgg': //是否出现规格
                                    this.isSizeShow = result;
                                    break;
                                case 'xsddly': //是否启用销售开单显示来源
                                    this.isUseSource = result;
                                    break;
                                case 'kdxspp': //是否显示品牌
                                    this.isShowBrand = result;
                                    break;
                                case 'xsdbsjj': //展示急件
                                    this.isUrgentShow = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        onUploadPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogImageVisible = true;
        },
        // 打开配件信息弹框
        showAPMsgDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.APMsgVisible = true;
            }
        },
        // 关闭配件信息弹框
        closeAPMsgDialog(edit) {
            this.APMsgVisible = false;
            if (edit) {
                this.getOrderDetail();
            }
        },
        // 历史销售
        showHistoryDialog(id) {
            if (id) {
                this.EntpTempGoodsIdEdit = id;
                this.historyVisible = true;
            }
        },
        closeHistoryDialog(edit) {
            this.historyVisible = false;
        },
        // 获取详情
        getOrderDetail() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/CheckAllDetails',
                    data: {
                        EntpCusOId: this.id
                    },
                    hideLoading: true
                })
                .then(res => {
                    let data = res.data;
                    this.orderData = data;

                    this.orderImages = data.OrderImages;

                    for (let j = 0; j < this.orderImages.length; j++) {
                        this.orderImages[j].name = this.orderImages[j].Id;
                        this.orderImages[j].url = this.$util.QN_URL_BASE + this.orderImages[j].ImgUrl;
                    }

                    this.dataList = data.DetailList;

                    this.receiveRecords = data.ReceiveRecords;
                    this.actionRecords = data.ActionRecords;

                    let CountSum = 0;
                    let SalesPriceSum = 0;
                    let BPriceSum = 0;
                    let TotalSales = 0;
                    this.dataList.forEach((e, i) => {
                        CountSum += e.Count;
                        SalesPriceSum += e.Price;
                        BPriceSum += e.BillingPrice * 1;
                    });
                    this.CountSum = CountSum;
                    this.SalesPriceSum = SalesPriceSum.toFixed(2);
                    this.BPriceSum = BPriceSum.toFixed(2);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getSummaries(param) {
            let spaceCount = 2; //最少有2个空格
            if (this.isOriginShow) spaceCount += 1;
            if (this.isSizeShow) spaceCount += 1;
            if (this.isShowBrand) spaceCount += 1;
            if (!this.isBPriceShow) {
                if (spaceCount == 2)
                    return ['', '', '合计：', `优惠金额：￥${this.orderData.DiscountAmount}`, this.CountSum, '', this.SalesPriceSum, this.orderData.SurplusMoney, ''];
                if (spaceCount == 3)
                    return ['', '', '', '合计：', `优惠金额：￥${this.orderData.DiscountAmount}`, this.CountSum, '', this.SalesPriceSum, this.orderData.SurplusMoney, ''];
                if (spaceCount == 4)
                    return [
                        '',
                        '',
                        '',
                        '',
                        '合计：',
                        `优惠金额：￥${this.orderData.DiscountAmount}`,
                        this.CountSum,
                        '',
                        this.SalesPriceSum,
                        this.orderData.SurplusMoney,
                        ''
                    ];
                if (spaceCount == 5)
                    return [
                        '',
                        '',
                        '',
                        '',
                        '',
                        '合计：',
                        `优惠金额：￥${this.orderData.DiscountAmount}`,
                        this.CountSum,
                        '',
                        this.SalesPriceSum,
                        this.orderData.SurplusMoney,
                        ''
                    ];
            } else {
                if (spaceCount == 2)
                    return [
                        '',
                        '',
                        '合计：',
                        `优惠金额：￥${this.orderData.DiscountAmount}`,
                        this.CountSum,
                        '',
                        this.SalesPriceSum,
                        this.BPriceSum,
                        this.orderData.SurplusMoney,
                        ''
                    ];
                if (spaceCount == 3)
                    return [
                        '',
                        '',
                        '',
                        '合计：',
                        `优惠金额：￥${this.orderData.DiscountAmount}`,
                        this.CountSum,
                        '',
                        this.SalesPriceSum,
                        this.BPriceSum,
                        this.orderData.SurplusMoney,
                        ''
                    ];
                if (spaceCount == 4)
                    return [
                        '',
                        '',
                        '',
                        '',
                        '合计：',
                        `优惠金额：￥${this.orderData.DiscountAmount}`,
                        this.CountSum,
                        '',
                        this.SalesPriceSum,
                        this.BPriceSum,
                        this.orderData.SurplusMoney,
                        ''
                    ];
                if (spaceCount == 5)
                    return [
                        '',
                        '',
                        '',
                        '',
                        '',
                        '合计：',
                        `优惠金额：￥${this.orderData.DiscountAmount}`,
                        this.CountSum,
                        '',
                        this.SalesPriceSum,
                        this.BPriceSum,
                        this.orderData.SurplusMoney,
                        ''
                    ];
            }
        },
        getSummaries_apply(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 2) {
                    let totalAmount = 0;
                    if (data.length > 0) totalAmount = Number(data[0].SumPayable);
                    let applyTotal = data.reduce((prev, curr) => {
                        if (curr.IsCancel) return prev;
                        else return prev + Number(curr.ApplyPay);
                    }, 0);
                    sums[index] = '剩余可申请：' + (totalAmount > applyTotal ? totalAmount - applyTotal : 0).toFixed(2);
                    return;
                } else if (index === 3) {
                    let sum = data.reduce((prev, curr) => {
                        if (curr.IsCancel || !curr.IsConfirm) return prev;
                        else return prev + Number(curr.NowPay);
                    }, 0);
                    sums[index] = '已收：' + sum.toFixed(2);
                    return;
                } else {
                    sums[index] = '';
                    return;
                }
            });
            return sums;
        },
        // 保存新明细
        save() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpSaleOrder/SaveCheckSaleGoodsDetails',
                    data: {
                        EntpCusOId: this.id,
                        EntpCusId: this.entpCusId,
                        CusSourcesName: this.orderData.CusSourcesName,
                        DetailList: this.dataList
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.errcode == 0) {
                        this.isEdit = false;
                        this.$util.successMsg(res.errmsg);
                    } else this.$util.errmsg(res.errmsg);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        //获取企业的功能设置结果
        getEntpFuncConfigData() {
            this.$util.getSysConfig('xsgdy').then(res => {
                this.funcConfig = res.Result;
            });
        },
        hideRPMsg() {
            this.showRAndPMsg = false;
        },
        showRPMsg() {
            this.showRAndPMsg = true;
        },
        hideOPMsg() {
            this.showOpRecordMsg = false;
        },
        showOPMsg() {
            this.showOpRecordMsg = true;
        }
    }
};
</script>
<style lang="less" scoped>
.purcounts-input-cell {
    .el-input-number {
        width: 100%;
    }

    .el-input {
        .el-input__inner {
            padding-left: 0;
            padding-right: 20px;
        }
    }

    .el-input-number__decrease,
    .el-input-number__increase {
        width: 20px;
    }
}
.calc-btn {
    margin-left: 10px;
}
.payment-tip {
    position: absolute;
    left: 0;
    bottom: -18px;
    line-height: 1;
    font-size: 12px;
    color: @font4Color;
}
.form-main {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: auto;
}
.form-bottom {
    width: 100%;
    display: flex;
    flex-direction: row;
    div {
        width: 50%;
    }
}
.section-title {
    display: flex;
    justify-content: space-between;
    height: 32px;
    line-height: 32px;
    padding: 0 20px;
    font-weight: bold;
    font-size: @font-sm;
    margin-left: -1px;
    background: @border3Color;
}
.edit-ctn {
    .div-table-cell {
        padding: 0 5px;
    }
}
.option-content {
    display: flex;
    line-height: 30px;

    .project-Name {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 12px;
    }
}
.business-content-main {
    min-width: 1440px;
}
.table-main {
    position: relative;
}
.div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.addresscls {
    display: flex;
    flex-direction: row;
}
.el-row {
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 10px;
    }
}
.apcode-cell {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .info-icon {
        margin-right: 10px;
    }
}
.tag {
    margin-left: 8px;
}
.img-e-op {
    height: 32px;
    width: 32px;

    img {
        height: 28px;
        width: 28px;
        margin-bottom: 2px;
    }
}

.section-magin {
    margin-bottom: 5px;
}
</style>
<style lang="less">
.el-col {
    border-radius: 4px;
}
.bg-purple-dark {
    background: #99a9bf;
}
.bg-purple {
    background: #d3dce6;
}
.bg-purple-light {
    background: #e5e9f2;
}

.row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
}
.check-code-class {
    .el-input__inner {
        border: 1px solid #f56c6c;
    }
}
.order-infoes {
    border: 1px solid @border3Color;
    padding-top: 10px;
    margin-bottom: 10px;

    .grid-content {
        border-radius: 4px;
        min-height: 32px;
    }
    .el-form-item {
        margin-bottom: 0px;
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__label {
        line-height: 32px;
        height: 32px;
    }

    .el-form-item__content {
        line-height: 32px !important;
        height: 32px;
        top: -1px;
    }
}
</style>
